import { createContext, useContext, useEffect, useState } from "react";
import { db } from "../firebase/firebase";
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore";
import { useAuth } from "./AuthContext";

const CardContext = createContext();

export const useCard = () => useContext(CardContext);

export const CardProvider = ({ children }) => {
    const { user } = useAuth(); // Get the current authenticated user
    const [cards, setCards] = useState([]);

    useEffect(() => {
        // Only fetch cards if a user is authenticated
        if (!user) return;
        const fetchCards = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "cards"));
                setCards(querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
            } catch (error) {
                console.error("Error fetching cards:", error);
            }
        };
        fetchCards();
    }, [user]);

    const addCard = async (name) => {
        if (!user) return; // Only allow card creation if user is authenticated
        try {
            const docRef = await addDoc(collection(db, "cards"), { name, categories: [] });
            const newCard = { id: docRef.id, name, categories: [] }; // create a new card object
            setCards(prevCards => [...prevCards, newCard]); // update state to include new card
        } catch (error) {
            console.error("Error adding card:", error);
        }
    };

    const deleteCard = async (id) => {
        if (!user) return;
        try {
            await deleteDoc(doc(db, "cards", id));
            setCards(prevCards => prevCards.filter(card => card.id !== id)); // update state to remove deleted card
        } catch (error) {
            console.error("Error deleting card:", error);
        }
    };

    return (
        <CardContext.Provider value={{ cards, addCard, deleteCard }}>
            {children}
        </CardContext.Provider>
    );
};
